module.exports = __webpack_public_path__ + "static/media/4.b27144d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/visual-electric/hero/4.png
// module id = 378
// module chunks = 0